import { IconButton } from "@mui/material";
import { jobOrderColNm } from "constants/jobOrderConstant"
import { shipmentColNm } from "constants/shipmentConstant";
// import { shipmentColNm } from "constants/shipmentConstant"
import dayjs from "dayjs";
import { ArticleRounded, ReceiptRounded } from "resource/muiImport";
import { numberFormat } from "utils";


export const financeialReportColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return params.id === 0? null: (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "JobOrdId",
    headerName: jobOrderColNm.JobOrdId,
    width: 80,
  },
  // {
  //   field: "RecvDocDte",
  //   headerName: shipmentColNm.RecvDocDte,
  //   width: 100,
  //   type: "dateTime",
  //   valueFormatter: (params) => {
  //     return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
  //   },
  // },
  {
    field: "TakeDteSt",
    headerName: jobOrderColNm.TakeDteSt,
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "CusSNm",
    headerName: jobOrderColNm.CusSNm,
    width: 100,
  },
  {
    field: "JobSNm",
    headerName: jobOrderColNm.JobSNm,
    width: 180,
  },
  {
    field: "CusRefNo",
    headerName: shipmentColNm.CusRefNo,
    width: 100,
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "ContSizeFull",
    headerName: jobOrderColNm.ContSizeFull,
    width: 100,
  },
  {
    field: "Bkg",
    headerName: jobOrderColNm.Bkg,
    width: 130,
  },
  // {
  //   field: "FullWt",
  //   headerName: jobOrderColNm.FullWt,
  //   width: 100,
  // },
  {
    field: "Loc",
    headerName: jobOrderColNm.Loc,
    width: 250,
  },
  {
    field: "ShpmTypNm",
    headerName: jobOrderColNm.ShpmTypNm,
    width: 100,
  },
  {
    field: "RcptNm",
    headerName: 'ใบเสร็จ',
    width: 40,
    align: "center",
    renderCell: ({row}) => row.id === 0? null: (
      <IconButton sx={{ p:0}} >
        <ReceiptRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "AptTm",
    headerName: jobOrderColNm.AptTm,
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "Ref1",
    headerName: "เบอร์โทรติดต่อ",
    width: 100,
  },
  // {
  //   field: "Agnt",
  //   headerName: jobOrderColNm.Agnt,
  //   width: 150,
  // },
  {
    field: "TakePlc",
    headerName: jobOrderColNm.TakePlc,
    width: 100,
  },
  {
    field: "RtnPlc",
    headerName: jobOrderColNm.RtnPlc,
    width: 100,
  },
  // {
  //   field: "Shipping",
  //   headerName: "Shipping",
  //   width: 100,
  // },
  {
    field: "JobNo",
    headerName: jobOrderColNm.JobNo,
    width: 180,
  },
  // {
  //   field: "RtnDteEn",
  //   headerName: jobOrderColNm.RtnDteEn,
  //   width: 100,
  // },
  // {
  //   field: "FreeTm",
  //   headerName: "Free Time",
  //   width: 100,
  // },
  {
    field: "ScSNm",
    headerName: jobOrderColNm.ScSNm,
    width: 100,
  },
  {
    field: "TlrTyp",
    headerName: jobOrderColNm.TlrTyp,
    width: 100,
  },
  {
    field: "LicNm",
    headerName: jobOrderColNm.LicNm,
    width: 100,
  },
  {
    field: "TlrLicNm",
    headerName: jobOrderColNm.TlrLicNm,
    width: 100,
  },
  {
    field: "DrvNm",
    headerName: jobOrderColNm.DrvNm,
    width: 100,
  },
  {
    field: "Tel",
    headerName: jobOrderColNm.Tel,
    width: 100,
  },
  {
    field: "FinDte",
    headerName: jobOrderColNm.FinDte,
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "IncE1",
    headerName: "ค่าขนส่ง",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "inc"
  },
  {
    field: "IncE3",//E3 + E5 
    headerName: "ยกตู้เปล่า|ผ่านลาน",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "inc"
  },
  {
    field: "IncE1018",
    headerName: "ใบหักลูกค้า",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "inc"
  },
  {
    field: "IncE4",
    headerName: "ค่าผ่านท่าเรือ",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "inc"
  },
  {
    field: "IncE2",
    headerName: "ค่าชอร์",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "inc"
  },
  {
    field: "IncOthAmnt",
    headerName: "ค่าอื่นๆ",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "inc"
  },
  {
    field: "IncOthAmntNm",
    headerName: "ชื่อค่าอื่นๆ",
    width: 100,
    cellClassName: "inc"
  },
  {
    field: "IncTotal",
    headerName: "รวมเก็บลูกค้า",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "inc"
  },
  {
    field: "ItmE87",
    headerName: "ค่าเที่ยว พขร.",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE88",
    headerName: "ค่าเตกค้าง",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE1032",
    headerName: "ค่าคลุมผ้าใบ",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE1000",
    headerName: " ค่าน้ำมัน ",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE1004",
    headerName: "ค่าปะยาง",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE1011",
    headerName: " ค่าดรอปตู้",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE1001",
    headerName: "ค่าล่วงเวลา",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE1020",
    headerName: "ค่า OT วันหยุด",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE1017",
    headerName: "ค่าเหยียบแผ่นดิน/ทำบัตร/ตรวจโรค",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmE1012",
    headerName: "ค่าปรับจราจร",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmOthAmnt",
    headerName: "คชจ. อื่นๆ",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "ItmOthAmntNm",
    headerName: "ชื่อคชจ. อื่นๆ",
    width: 100,
    cellClassName: "itm"
  },
  // {
  //   field: "ItmCostTotal",
  //   headerName: "รวม คชจ.",
  //   width: 100,
  //   type: "number",
  //   align: "right",
  //   valueFormatter: (params) => {
  //     return params.value == null ? "-" : numberFormat(+params.value);
  //   },
  //   cellClassName: "itm"
  // },
  {
    field: "ItmSumCostAmnt",
    headerName: "รวม คชจ.",
    width: 100,
    type: "number",
    align: "right",
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
    cellClassName: "itm"
  },
  {
    field: "PayAmnt",
    headerName: "ยอดโอนเงิน",
    width: 100,
    type: "number",
    align: "right",
    // valueGetter: ({ row }) => row.PayTm ? row.IncTotal: null,
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
  },
  {
    field: "BalAmnt",
    headerName: "คงเหลือรับ-คืนบัญชี",
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row }) => row.PayAmnt && row.ItmSumCostAmnt ? row.PayAmnt - row.ItmSumCostAmnt: null,
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
  },
  {
    field: "RtnTransfer",
    headerName: "วันที่โอนคืนเงินสำรองให้อ้อม",
    width: 100,
  },
  {
    field: "ScE1Laast",
    headerName: "ค่าขนส่ง SUB",
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row }) => row.ScE1,
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
  },
  {
    field: "IncE1Last",
    headerName: "วางบิลค่าขนส่ง",
    width: 100,
    type: "number",
    align: "right",
    valueGetter: ({ row }) => row.IncE1,
    valueFormatter: (params) => {
      return params.value == null ? "-" : numberFormat(+params.value);
    },
  },
  {
    field: "Ref2",
    headerName: "อ้างอิง2",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "InvNote",
    headerName: jobOrderColNm.InvNote,
    flex: 1,
    minWidth: 150,
  },
  {
    field: "Rmk",
    headerName: "หมายเหตุ",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "ScInvNo",
    headerName: "ใบแจ้งหนี้ SUB",
    width: 180,
  },
  {
    field: "ScInvDte",
    headerName: "วันที่ใบแจ้งหนี้ SUB",
    width: 100,
  },
  {
    field: "XpssDocNum",
    headerName: "เลขที่เอกสาร รับแจ้งหนี้",
    width: 100,
  },
  {
    field: "XpssDocDte",
    headerName: "วันที่เอกาสาร รับแจ้งหนี้",
    width: 100,
  },
  {
    field: "PVDte",
    headerName: "วันที่_จ่ายชำระ  SUB",
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "PVNo",
    headerName: "ใเลขที่ PB จ่ายของ EEC",
    width: 100,
  },
  {
    field: "InvNo",
    headerName: "Invoice No. (รายได้)",
    width: 150,
  },
  {
    field: "RVPayTm",
    headerName: "RV_EEC รับชำระ",
    width: 100,
    // type: "dateTime",
    // valueFormatter: (params) => {
    //   return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    // },
  },
  {
    field: "RVNo",
    headerName: "RV_EEC รับชำระ",
    width: 100,
  },
  // {
  //   field: "GJ_EEC",
  //   headerName: "GJ_EEC ค้างจ่าย",
  //   width: 100,
  // },
  {
    field: "JobTagNms",
    headerName: "Job Tag",
    width: 100,
  },
  {
    field: "E1Diff",
    headerName: "เทียบราคาจ่าย-รับ",
    width: 100,
    valueGetter: ({ row }) => row.IsSub === 1 ?  +(row.IncE1 || 0) - +(row.ScE1 || 0): +(row.IncE1 || 0) - +(row.ItmSumCostAmnt || 0), 
    valueFormatter: (params) => {
      return  params.value == null ? "-" : numberFormat(+params.value);
    },

  },
]